import * as React from 'react'
import { Field, useField } from 'formik'
import { DebouncedTextField } from '@user/components/Formik'
import Grid from '@mui/material/Grid'
import { TextFieldProps } from '@mui/material/TextField'
import { RuleFieldHelperText } from './RuleFieldHelperText'
import { useMemo } from 'react'

interface Props {
  textFieldProps?: TextFieldProps
  maxCharLength?: number
}

export function RuleName(props: Props) {
  const { textFieldProps, maxCharLength = 50 } = props
  const [name] = useField<string>('name')
  const nameLength = useMemo(() => (name.value ? name.value.length : 0), [name])

  const helperMessage =
    'Give this Assignment rule a unique name. Name must be between 5 and 50 characters.'

  return (
    <Grid item xs md={12}>
      <Field
        name="name"
        label="Name"
        required
        component={DebouncedTextField}
        FormHelperTextProps={{ component: 'div' }}
        helperText={
          <RuleFieldHelperText
            message={helperMessage}
            maxLength={maxCharLength}
            counter={nameLength}
          />
        }
        InputProps={{
          inputProps: {
            'data-test-id': `leadAssignmentRuleNameInput`,
            maxLength: maxCharLength,
          },
        }}
        {...{ debounceDelay: 0, ...textFieldProps }}
      />
    </Grid>
  )
}
